export const normalPlayer = [
  {
    name: '',
    color: '#F06292',
    points: [1, 2],
    categories: [483],
    translationKey: 'chalkboard.defensive.player.balls_recovered_in_challenge',
    singleName: 'Balón recuperado',
  },
  {
    name: '',
    color: '#B4005A',
    points: [1, 2],
    categories: [484],
    translationKey: 'chalkboard.defensive.player.balls_recovered_without_challenge',
    singleName: 'Balón recuperado',
  },
  {
    name: '',
    color: '#455A64',
    points: [1],
    categories: [5],
    translationKey: 'chalkboard.defensive.player.successful_1_on_1',
    singleName: '1 vs 1 exitoso defensivo',
  },
  {
    name: '',
    color: '#4CAF50',
    points: [1],
    categories: [209],
    translationKey: 'chalkboard.defensive.player.unsuccessful_1_on_1',
    singleName: '1 vs 1 no exitoso defensivo',
  },
  {
    name: '',
    color: '#305496',
    points: [1, 2],
    categories: [23],
    translationKey: 'chalkboard.defensive.player.balls_won_own_penalty_box',
    singleName: 'Balón ganado',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1, 2, 3],
    categories: [517],
    translationKey: 'chalkboard.defensive.player.allowed_crosses',
    singleName: 'Juego aéreo resto del campo',
  },
  {
    name: '',
    color: '#700000',
    points: [1],
    categories: [34],
    translationKey: 'chalkboard.defensive.player.clearances',
    singleName: 'Rechace',
  },
  {
    name: '',
    color: '#CC0000',
    points: [1],
    categories: [518],
    translationKey: 'chalkboard.defensive.player.slide_tackles',
    singleName: 'Barrida',
  },
];

export const goalkeeper = [
  {
    name: '',
    color: '#26C6DA',
    points: [1, 2, 3],
    categories: [40],
    translationKey: 'chalkboard.defensive.goalkeeper.goals_received',
    singleName: 'Gol recibido',
  },
  {
    name: '',
    color: '#F06292',
    points: [1, 2],
    categories: [39],
    translationKey: 'chalkboard.defensive.goalkeeper.saves',
    singleName: 'Atajada',
  },
  {
    name: '',
    color: '#455A64',
    points: [1, 2],
    categories: [42],
    translationKey: 'chalkboard.defensive.goalkeeper.successful_aerial_game',
    singleName: 'Juego aéreo exitoso',
  },
  {
    name: '',
    color: '#4CAF50',
    points: [1, 2, 3],
    categories: [43],
    translationKey: 'chalkboard.defensive.goalkeeper.unsuccessful_aerial_game',
    singleName: 'Juego aéreo no exitoso',
  },
  {
    name: '',
    color: '#FFF176',
    points: [1],
    categories: [41],
    translationKey: 'chalkboard.defensive.goalkeeper.1_on_1',
    singleName: '1 vs 1',
  },
  {
    name: '',
    color: '#FFA726',
    points: [1],
    categories: [312],
    translationKey: 'chalkboard.defensive.goalkeeper.recovered_balls',
    singleName: 'Balón recuperado',
  },
];

export const allCategories = [...normalPlayer, ...goalkeeper];
